import React from 'react'
import { Grid } from '@mui/material'

import Support from 'components/Support'

const ProfileFormHeader = () => {
  return (
    <Grid
      container
      height="fit-content"
      sx={{ backgroundColor: '#E4CAFB' }}
      alignItems="center"
      p="8px 16px"
      mb={4}
    >
      <Grid width={80} />
      <Grid mx="auto">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="107"
          height="32"
          viewBox="0 0 107 32"
          fill="none"
        >
          <path
            d="M42.7132 4.0816V4H29.8462V4.0816C32.0843 4.0816 32.3799 5.41472 32.3799 8.93616V14.1107H24.8771V8.93616C24.8771 5.41472 25.1739 4.0816 27.4109 4.0816V4H14.5449V4.0816C18.0992 4.0816 18.0992 5.9414 18.0992 9.92275V21.1112C18.0992 24.9612 18.0992 26.9524 14.5449 26.9524V27.034H27.4109V26.9524C25.1739 26.9524 24.8771 25.6193 24.8771 22.0978V15.428H32.3799V22.0978C32.3799 25.6193 32.0843 26.9524 29.8462 26.9524V27.034H42.7132V26.9524C39.1589 26.9524 39.1589 24.9612 39.1589 21.1112V9.92275C39.1589 5.9414 39.1589 4.0816 42.7132 4.0816ZM58.7881 27.265C60.1371 27.265 62.0615 26.8538 64.7595 26.0145L64.7437 25.9319C62.0785 26.6557 61.8644 25.0608 61.8644 22.8587V9.52854L52.6173 10.7822L52.6343 10.8638C55.6619 10.4643 55.7763 11.524 55.7763 13.937V23.2783C54.7897 24.1335 53.819 25.011 52.8812 25.011C50.9737 25.011 50.8073 22.9212 50.8073 21.5711V9.52854L41.5613 10.7822L41.5772 10.8638C44.6048 10.4696 44.7203 11.5219 44.7203 13.937V22.4274C44.7203 25.7835 45.8722 27.265 48.5353 27.265C50.5424 27.265 52.5495 26.4755 55.8071 23.7107C55.7085 26.0145 56.3666 27.265 58.7859 27.265M77.084 15.1366H71.6731C71.9084 12.7755 72.7954 9.9609 74.7961 9.9609C76.977 9.9609 77.3267 12.8698 77.084 15.1366ZM83.418 20.2878L83.3682 20.256C82.2162 22.2462 80.295 23.3493 77.6923 23.3493C73.3973 23.3493 71.6212 19.9434 71.6043 16.5036H82.6942C83.7465 12.3251 80.7528 9.52854 75.3228 9.52854C69.9585 9.52854 65.4176 13.0489 65.4176 18.3146C65.4176 23.5804 68.8405 27.265 74.2037 27.265C78.9099 27.265 81.8708 24.2045 83.418 20.2878ZM91.5449 24.1028C91.5449 23.478 91.3596 22.8673 91.0125 22.3478C90.6654 21.8283 90.172 21.4234 89.5948 21.1843C89.0176 20.9452 88.3824 20.8826 87.7696 21.0045C87.1568 21.1264 86.5939 21.4272 86.1521 21.869C85.7104 22.3108 85.4095 22.8737 85.2876 23.4865C85.1657 24.0993 85.2283 24.7345 85.4674 25.3117C85.7065 25.8889 86.1114 26.3823 86.6309 26.7294C87.1504 27.0765 87.7611 27.2618 88.3859 27.2618C89.2237 27.2618 90.0272 26.929 90.6197 26.3366C91.2121 25.7441 91.5449 24.9406 91.5449 24.1028Z"
            fill="#03101D"
          />
        </svg>
      </Grid>
      <Support />
    </Grid>
  )
}

export default ProfileFormHeader
